module.exports = __webpack_public_path__ + "static/media/Loan.6eab3d06.svg";